import PropTypes from "prop-types";
import { Box, Container } from "@mui/material";
import AuthHeader from "./Header";
import AuthFooter from "./Footer";
import { LoginArtIcon } from "../../Icons/LivisIcons";

const AuthMain = (props: any = null) => {
  return (
    <>
      <Box
        className="livis-auth-main livis-auth-art-work"
      //  sx={{ position: "relative", overflow: "hidden" }}
      >
        {/* Responsive background image */}
        {/* <img
          src={props.loginArt}
          alt="Login Art"
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: 0,
            pointerEvents: "none",
          }}
        /> */}
        <LoginArtIcon
        //  style={{
        //    position: "absolute",
        //    left: 0,
        //    top: 0,
        //    width: "100%",
        //    height: "100%",
        //    objectFit: "cover",
        //    zIndex: 0,
        //    pointerEvents: "none",
        //  }}
          className="livis-login-art-icon"
        />
        {/* Content above the image */}
        <Box 
        className="livis-auth-main-auth-header-wrap"
      //  sx={{ position: "relative", zIndex: 1 }}
      >
          <AuthHeader
            livis_logo={props.livis_logo}
            lincode_demo_url={props.lincode_demo_url}
          />
          {props.children}
          <AuthFooter />
        </Box>
      </Box>
    </>
  );
};

export default AuthMain;
